import React, { ReactElement, useEffect } from 'react';
import { Breadcrumbs, HiddenPriorityTitle, homeBreadcrumb } from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import routes from '../../routing/routes';
import Layout from '../Layout';
import NahlasenieChyby from '../../module/NahlasenieChyby';
import { useClient } from '../../context/ClientStatusContext';
import { getNahlasenieChyby } from '../../client/nahlasenieChybyClient';
import SuccessMessages from '../../module/SuccessMessages';
import insertScripts from '../../function/insertScripts';

const NahlasenieChybyPage = (): ReactElement => {
  const {
    data: nahlasenieChyby,
    status: nahlasenieChybyStatus,
  } = useClient(() => getNahlasenieChyby());

  useEffect(() => {
    if (nahlasenieChyby) {
      insertScripts([
        `${process.env.REACT_APP_SUBPATH}js/linkHandler.js`,
      ]);
    }
  }, [nahlasenieChyby]);

  return (
    <Layout>
      <HiddenPriorityTitle>Nahlásenie chyby</HiddenPriorityTitle>
      <Breadcrumbs
        routeList={[
          homeBreadcrumb(process.env.REACT_APP_STATICKY_OBSAH_URL as string),
          {
            to: routes.nahlasenieChyby.to,
            heading: routes.nahlasenieChyby.name,
          },
        ]}
      />
      <SuccessMessages />
      <Loader loading={nahlasenieChybyStatus?.loading}>
        <NahlasenieChyby nahlasenieChybyItems={nahlasenieChyby} />
      </Loader>
    </Layout>
  );
};

export default NahlasenieChybyPage;
